// Cómo se usa la app (PostHog): pantallas que se ven, clics, grabaciones de
// sesión. Solo arranca si el build trae la clave (REACT_APP_POSTHOG_KEY, se
// pasa en docker-compose.prod.yml): en desarrollo no se manda nada.
import posthog from 'posthog-js';
import type { User } from '../../domain/User';

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const enabled = !!KEY;

export function initAnalytics() {
  if (!KEY) return;
  posthog.init(KEY, {
    api_host: 'https://us.i.posthog.com',
    // Entre otras cosas registra cada cambio de pantalla del router como un
    // pageview, sin tener que avisarle desde cada página.
    defaults: '2026-08-30',
    // Perfil solo para quien inició sesión; las visitas a /login no cuentan
    // como personas.
    person_profiles: 'identified_only',
    // Los errores de JavaScript (los que dejan la pantalla en blanco) llegan
    // a Error tracking con el navegador, el dispositivo y el stack.
    capture_exceptions: true,
    session_recording: {
      // Nada de lo que se escribe (contraseñas, nombres de sitios, notas)
      // queda en las grabaciones. Para tapar un texto en pantalla, ponerle
      // la clase "ph-no-capture".
      maskAllInputs: true,
    },
  });
}

// Se identifica por el id interno, nunca por el email.
export function identifyUser(user: User) {
  if (!enabled) return;
  posthog.identify(user.id, { is_admin: user.isAdmin, created_at: user.createdAt });
}

// Al cerrar sesión, lo que siga en este dispositivo es otra persona.
export function resetAnalytics() {
  if (!enabled) return;
  posthog.reset();
}

// Un error que la app atajó (p. ej. el ErrorBoundary): igual se quiere ver.
export function reportError(error: unknown, context?: Record<string, unknown>) {
  if (!enabled) return;
  posthog.captureException(error, context);
}
